import request from './plugins/request'

// 获取文章类型列表
export let categoryList = () => {
  return request({
    url: '/category/list',
    params:{
      token:localStorage.getItem('token')
    },
    method:'post'
  })
}

// 创建一个类型
export let creatCategory = (params = {}) => {
  let myParams = Object.assign({token:localStorage.getItem('token')},params);
  return request({
    url: '/category/add',
    params: myParams,
    method:'post'
  })
}

// 删除一个类型
export let deleteCategory = (params = {}) => {
  let myParams = Object.assign({token:localStorage.getItem('token')},params);
  return request({
    url: '/category/delete',
    params: myParams,
    method:'post'
  })
}


// 查看一个类型的详情
export let detailCategory = (params = {}) => {
  let myParams = Object.assign({token:localStorage.getItem('token')},params);
  return request({
    url: '/category/detail',
    params: myParams,
    method:'post'
  })
}

// 修改一个类型的详情
export let updateCategory = (params = {}) => {
  let myParams = Object.assign({token:localStorage.getItem('token')},params);
  return request({
    url: '/category/update',
    params: myParams,
    method:'post'
  })
}
